import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: "I'm not an art therapist. Can I use this?",
  a: "Yes, within your training, license and scope of practice. These are art-based session plans for counselors, social workers, therapists and art therapists. They are not art therapy training and don't replace clinical judgment. Bonus 02, The Scope Checklist, shows how to describe your work without claiming a protected title, and sessions marked Deep are for clinicians trained in trauma-informed or art therapy practice."
}, {
  q: "I'm an art therapist and I work client-led. Isn't this too formulaic?",
  a: 'The arc is scaffolding, not a script. The client owns the art: they decide what it is called, what it means and where it goes. Every directive offers real choices, and the processing questions move from the image to meaning without ever interpreting the work. Adapt freely to the person in front of you.'
}, {
  q: 'My clients say "I can\'t draw." Will this work for them?',
  a: "That's who Volume 1 was written for: no drawing skill needed, The Can't-Draw Reset for a client who freezes, and Shapes Only for the blank-page panic. Bonus 01 adds 30-second scripts for the teen who says \"this is childish.\""
}, {
  q: 'What ages and formats does it cover?',
  a: 'Every session is marked for kids (5–11), teens (12–17) and/or adults, and comes with easier, group and online adaptations. Volume 4 is built around group work, with one-to-one versions of its group sessions.'
}, {
  q: 'What materials do I need?',
  a: 'A core kit you probably already have: pencil and paper (M1), plus color (M2) and simple collage supplies (M3). Each volume lists only what it adds. No expensive supplies.'
}, {
  q: 'Can I run the sessions online?',
  a: 'Yes. Every session includes an online adaptation, and Bonus 05 covers the set-up: what the client needs at home, how to see the art on camera and how to protect privacy.'
}, {
  q: 'Do I have to start at Week 1?',
  a: 'No. Each volume works on its own with any client. Bonus 03, The Whole-Pack Session Index, lets you pick the right session by age, format, time and intensity.'
}, {
  q: 'Does it cover grief or difficult material?',
  a: 'Volume 5 covers stress, change and loss with containment built in: The Container First Rule, a grounding protocol and a safeguarding and referral checklist. The two grief sessions are marked Deep, for trained clinicians. No clinical outcomes are promised.'
}, {
  q: 'Is it printable or digital only?',
  a: 'Landscape PDFs that read well on a tablet in session and print cleanly, worksheets included.'
}, {
  q: 'How do I get it?',
  a: 'Instant download after checkout, plus an email with your files. Lifetime access to what you bought.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(null);
  return <section aria-labelledby="faq-heading" className="paper-grain w-full bg-paper text-navy" data-id="element-118" data-mp="o353uh2rkdnr">
      <div className="mx-auto max-w-3xl px-5 py-16 sm:py-20" data-id="element-119" data-mp="2zm1anbw7xvma">
        <div className="text-center" data-id="element-120" data-mp="33qirb27a7ssu">
          <p className="text-sm font-semibold text-teal-deep" data-id="element-121" data-mp="33nd1fkqtwmw2">Before you buy</p>
          <h2 id="faq-heading" className="mt-3 font-display text-3xl font-semibold text-navy sm:text-5xl" data-id="element-122" data-mp="38nhjhf7dxpoe">
            Frequently asked questions
          </h2>
        </div>

        <div className="mt-8 grid gap-2.5" data-id="element-123" data-mp="3idkcvgif55n9">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.q} className="overflow-hidden rounded-2xl bg-white shadow-card" data-id="element-124" data-mp="3nfjf2n2f9wim" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left font-display text-[15px] font-medium text-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-teal" data-id="element-125" data-mp="3rd7bxvnodzd5">
                  {faq.q}
                  {isOpen ? <MinusIcon className="h-5 w-5 flex-none text-teal-deep" aria-hidden="true" data-id="element-126" data-mp="11rm4vc0rs7w1" /> : <PlusIcon className="h-5 w-5 flex-none text-teal-deep" aria-hidden="true" data-id="element-127" data-mp="1gn20hlh00buj" />}
                </button>
                {isOpen && <p className="px-4 pb-4 text-sm text-navy-soft" data-id="element-128" data-mp="nzpdja6xe20p">{faq.a}</p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}